module.exports = __webpack_public_path__ + "media/images/placeholder-tasks-d7ae6bc3.png";